import { render, staticRenderFns } from "./ElCounterV2.vue?vue&type=template&id=0d23bdb3"
import script from "./ElCounterV2.vue?vue&type=script&lang=js"
export * from "./ElCounterV2.vue?vue&type=script&lang=js"
import style0 from "./ElCounterV2.vue?vue&type=style&index=0&id=0d23bdb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports